import { resumeSubscription, useUserMutation } from "../../../lib";

export const useResumeSubscription = () => {
  const [resumeSubscriptionMutation] = useUserMutation(
    resumeSubscription,
    "Subscription resumed"
  );

  return resumeSubscriptionMutation;
};
